import { SET_LOGIN_MODAL, SET_RATING_MODAL } from "../../actions/types/types";

const initState = {
  loginModal: false,
  ratingModal: false,
  id: "",
  type: "",
  questionnaireModalOpen: false,
};

const ModalReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_LOGIN_MODAL:
      return {
        ...state,
        loginModal: action.payload.data,
      };
    case SET_RATING_MODAL:
      return {
        ...state,
        ratingModal: action.payload.data.flag,
        id: action.payload.data.id,
        type: action.payload.data.type,
      };
    case "SET_QUESTIONNAIRE_MODAL":
      return {
        ...state,
        questionnaireModalOpen: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default ModalReducer;
